import React from "react"
import { Link, useHistory } from "react-router-dom"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import settingsIcon from "../../../assets/images/icons/settings-icon.svg"
import { replaceSlashes } from "../../../utils/commonUtils"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { GetCustomizationCategoryListing } from "../../../api/api.service"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import { Pagination } from "../../../components/Pagination"
import { APP_ROUTES } from "../../../helpers/routeHelpers"
import { getRoute } from "../../../helpers/routeHelpers"
import { SearchBox } from "../../../components/SearchBox"
import useRenderUsedIn from "hooks/useRenderUsedIn"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import { UpdateGlobalPersonalizationCategorySequence } from "api/api.service"
import { SortOrder } from "constants"
import { EquipmentCategoryItemsStatus } from "constants"
import { EquipmentCategoriesStatus } from "constants"
import ActiveInactiveSwitch from "pages/Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"

const COLUMNS = {
   FEATURE_NAME: "Feature Name",
   DATE_EDITED: "Date Edited",
   NO_OF_ITEMS: "No. of Items",
   USED_IN: "Used In",
   STATUS: "Status",
   ACTION: "Action",
}

const DATA_KEY = "data"
const TOTAL_KEY = "total"
const INFINITE_LIMIT_COUNT = -1

const GlobalPersonalization = () => {
   const history = useHistory()

   const {
      data,
      isFetching,
      page,
      pageSize,
      total,
      searchText,
      handleSearchChange,
      handlePageClick,
      onChangePageSize,setTableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetCustomizationCategoryListing,
      params: {
         page: 1,
         limit: INFINITE_LIMIT_COUNT,
         direction: SortOrder.ASC,
         column: "sequenceNo",
      },
      deps: [],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   const renderUsedIn = useRenderUsedIn({
      listKey: "configuratorTrailerCustomizations",
   })

   const handleNavigateToSettings = obj => {
      return history.push(
         getRoute(
            APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_CUSTOMIZATION_ITEMS,
            {
               categoryId: obj.id,
               categoryName: replaceSlashes(obj.name),
            }
         )
      )
   }
   

   const handleDragEnd = async result => {
      if (!result.destination) return

      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      let payload = {
         sequenceItems: items.map((trailerObj, ind) => ({
            id: Number(trailerObj.id),
            sequenceNo: ind,
         })),
      }

      try {
         await UpdateGlobalPersonalizationCategorySequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }
   return (
      <>
         <Link to={APP_ROUTES.CONFIGURATOR_TRAILERS}>
            <div className="d-flex align-items-center gap-2 configurator-top-link">
               <span className="configurator-global-arrow">&lt;</span>{" "}
               Configurator Settings
            </div>
         </Link>

         <div className="mb-3 trailer-container px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <h3 className="configurator-global-heading">Personalization</h3>
               <div />
            </div>
         </div>

         <div className="mb-3 px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness">
               <div className="status-search-con wh-im-dpgi-status me-2"></div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              data={data}
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              tableClasses="base-feature-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.FEATURE_NAME,
                                    render: row => {
                                       return (
                                          <TruncatedTextWithTooltip
                                             text={row.name}
                                          />
                                       )
                                    },
                                 },
                                 {
                                    title: COLUMNS.DATE_EDITED,
                                    render: row =>
                                       convertDateTime({
                                          date: row?.updatedAt,
                                          customFormat:
                                             dateTimeFormat.casitaCustomDateFormat,
                                          dateOnly: true,
                                       }),
                                 },
                                 {
                                    title: COLUMNS.USED_IN,
                                    render: renderUsedIn,
                                 },
                                 {
                                    title: COLUMNS.NO_OF_ITEMS,
                                    render: row => (
                                       <span className="text-primary ">
                                          {row?.totalItems ?? 0}
                                       </span>
                                    ),
                                 },
                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={true}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={() => {}}
                                          isChecked={
                                             data?.status ==
                                             EquipmentCategoryItemsStatus.Active
                                          }
                                       />
                                    ),
                                 },
                                 {
                                    title: COLUMNS.ACTION,
                                    render: row => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={settingsIcon}
                                             onClick={() =>
                                                handleNavigateToSettings(row)
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
               {/* <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               /> */}
            </Col>
         </Row>
      </>
   )
}

export default GlobalPersonalization
